import { MaskedInput } from '@thaborach/react-text-mask';
import { cx } from 'class-variance-authority';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

interface Mask {
  prefix?: string;
  suffix?: string;
  includeThousandsSeparator?: boolean;
  thousandsSeparatorSymbol?: string;
  allowDecimal?: boolean;
  decimalSymbol?: string;
  decimalLimit?: number;
  requireDecimal?: boolean;
  allowNegative?: boolean;
  allowLeadingZeroes?: boolean;
  integerLimit?: number;
}

const defaultMaskOptions: Mask = {
  prefix: '',
  suffix: '',
  includeThousandsSeparator: false,
  thousandsSeparatorSymbol: ',',
  allowDecimal: false,
  decimalSymbol: '',
  decimalLimit: 2, // how many digits allowed after the decimal
  integerLimit: 6, // limit length of integer numbers
  allowNegative: false,
  allowLeadingZeroes: false,
  requireDecimal: false,
};

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  inputmode?: string;
  maskOptions?: Mask;
  error?: boolean;
}

const CurrencyInput = ({
  maskOptions,
  inputMode,
  disabled,
  error,
  type = 'text',
  value,
  defaultValue,
  ...inputProps
}: Props) => {
  const currencyMask = createNumberMask({
    ...defaultMaskOptions,
    ...maskOptions,
  });
  return (
    <MaskedInput
      mask={currencyMask}
      {...inputProps}
      value={value as string | undefined}
      defaultValue={defaultValue as string | undefined}
      type={type as 'text' | 'tel' | 'url' | 'password' | 'search'}
      onFocus={(e) => e.target.select()}
      disabled={disabled}
      inputMode={inputMode ?? 'text'}
      className={cx([
        'w-full grow cursor-[inherit] border-none border-transparent bg-transparent  leading-input ',
        disabled ? 'select-none text-brand-gray' : 'text-brand-black',
        error ? 'border-red-500' : 'border-brand-gray',
        inputProps.className,
      ])}
    />
  );
};

export default CurrencyInput;
